import { fuzzyMatch, FuzzyMatchCandidate } from '../fuzzyMatch'

interface NormalizerOption {
  id: string
  value: string
}

/**
 * Normalize an input string to match one of the provided options using fuzzy matching
 *
 * @param input - The input string to normalize
 * @param options - Array of {id, value} options to normalize against
 * @param aliases - Optional map of option IDs to arrays of alias strings
 * @returns The matching option ID or undefined if no match
 */
export default function fuzzyNormalize (
  input: string | undefined,
  options: NormalizerOption[],
  aliases: Record<string, string[]> = {}
): string | undefined {
  if (input === undefined || input === null || input === '') {
    return undefined
  }

  const stringValue: string = String(input).trim()
  const validIds: string[] = options.map(opt => opt.id)

  if (validIds.includes(stringValue)) {
    return stringValue
  }
  if (validIds.includes(stringValue.toUpperCase())) {
    return stringValue.toUpperCase()
  }

  const candidates: Array<FuzzyMatchCandidate<string>> = options.map(option => ({
    result: option.id,
    matchStrings: [
      option.id,
      option.value,
      ...(aliases[option.id] || [])
    ]
  }))

  const match: string | null = fuzzyMatch(stringValue, candidates)
  return match ?? undefined
}
